import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';

import { EditPerson, Person } from '../../interfaces/persons.interface';
import { PersonsService } from '../../services/persons.service';

import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { UsersService } from '../../services/users.service';
import { Subject, takeUntil } from 'rxjs';
import { User } from '../../interfaces/users.interface';
import { ParnterEditComponent } from '../parnter-edit/parnter-edit.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PwaService } from '../../services/pwa.service';

@Component({
  selector: 'app-dashboard',
  standalone: false,
  templateUrl: './dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(ParnterEditComponent) partnerEditComponent?: ParnterEditComponent;

  selectedTabIndex = 0;
  private $destroy = new Subject<void>();// BehaviorSubject to track component destruction
  private isLoadingPerson = false; // Flag to prevent duplicate calls

  isAcceptedPolicy = false;
  acceptForm!: FormGroup;

  user: User | null = null;
  persons: Person[] = []; // Changed to array
  person: Person = {} as Person; // Keep for backward compatibility or use first person
  constructor(private personService: PersonsService, private usersService: UsersService, private router: Router,
    private snackBar: MatSnackBar, private fb: FormBuilder, private pwaService: PwaService) {

    if (!navigator.onLine) {
      this.snackBar.open('Brak połączenia z internetem. Panel nie jest dostępny offline.', 'Zamknij', {
        duration: 4000,
        panelClass: ['error-snackbar'],
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
      });
      this.router.navigate(['/']);
      return;
    }

    this.usersService.loggedIn.pipe(takeUntil(this.$destroy)).subscribe(isLogged => {
      if (!isLogged) {
        this.snackBar.open('Musisz być zalogowany, aby zobaczyć panel.', 'Zamknij', {
          duration: 3000,
          panelClass: ['error-snackbar'],
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
        this.router.navigate(['/login']);
      }
    });


  }

  reloadPerson(): void {
    // Prevent duplicate calls
    if (this.isLoadingPerson) {
      return;
    }

    this.isLoadingPerson = true;
    this.personService.getCurrent().pipe(takeUntil(this.$destroy)).subscribe({
      next: data => {
        this.persons = data;

        this.person = data.length > 0 ? data[0] : {} as Person; // Use first person or empty object
        this.personService.current$.next(data);
        this.isLoadingPerson = false;
      },
      error: err => {
        console.error('reloadPerson error:', err);
        this.isLoadingPerson = false;
        this.snackBar.open('Nie udało się pobrać danych użytkownika.', 'Zamknij', {
          duration: 4000,
          panelClass: ['error-snackbar'],
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
        this.router.navigate(['/login']);
      }
    });
  }

  ngOnInit(): void {

    // Initialize accept form
    this.acceptForm = this.fb.group({
      acceptPolicy: [false, Validators.requiredTrue]
    });

    this.user = this.usersService.getCurrentUser();

    //this.isAcceptedPolicy = Boolean(this.user?.accept_policy);
    this.isAcceptedPolicy = true;


    // Initialize form value based on current user
    if (this.isAcceptedPolicy) {
      this.acceptForm.patchValue({
        acceptPolicy: false
      });
    }

    

    if (this.user === null) {
      this.snackBar.open('Nie udało się pobrać danych użytkownika.', 'Zamknij', {
        duration: 4000,
        panelClass: ['error-snackbar'],
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
      });
      this.router.navigate(['/login']);
      return;
    }
    // ...your existing code...
    if (this.person && this.person.type === 'CITIZEN') {
      //this.selectedTabIndex = 1; // Index of "Twoje Dokumenty" tab
    }

    this.reloadPerson();
  }

  ngAfterViewInit(): void {

  }



  // This method can be called from child components via (personChanged)="onPersonChanged()"
  onPersonChanged(): void {
    this.reloadPerson();
  }

  onTabChanged(index: number): void {
    this.selectedTabIndex = index;
  }

  onCheckUserType(editPerson: EditPerson): void {
    setTimeout(() => {
      if (editPerson.type === 'CITIZEN') {
        this.selectedTabIndex = 2; // "Twoje Dokumenty" tab index (0-based)
      } else if (editPerson.type === 'CHILDREN') {
        this.selectedTabIndex = 1; // "Twoje Partnerstwo" tab index (0-based)
      } else if (editPerson.type === 'SENIOR') {
        this.selectedTabIndex = 2; // Default tab index (e.g., "Podstawowe Dane")
      } else if (editPerson.type === 'STUDENT') {
        this.selectedTabIndex = 2; // Default tab index (e.g., "Podstawowe Dane")
      }
    }, 1000);


  }


  onPolicyAcceptanceChange(): void {
    if (this.acceptForm.invalid) return;

    const acceptPolicy = this.acceptForm.get('acceptPolicy')?.value;

    this.usersService.updateCurrent({ accept_policy: acceptPolicy }).subscribe({
      next: () => {



        this.snackBar.open('Polityka prywatności została zaakceptowana', 'Zamknij', {
          duration: 3000,
          panelClass: ['success-snackbar'],
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });

        // Recheck PWA install eligibility after policy acceptance
        this.pwaService.recheckEligibility();

        this.isAcceptedPolicy = acceptPolicy;

      },
      error: (err: any) => {
        let errorMessage = 'Wystąpił błąd podczas zapisywania!';
        if (err.status === 400) {
          errorMessage = 'Błędne dane.';
        } else if (err.status === 500) {
          errorMessage = 'Błąd serwera. Spróbuj ponownie później.';
        }

        this.snackBar.open(errorMessage, 'Zamknij', {
          duration: 20000,
          panelClass: ['error-snackbar'],
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });

        // Revert checkbox on error
        this.acceptForm.patchValue({
          acceptPolicy: this.isAcceptedPolicy
        });
      }
    });
  }


  ngOnDestroy(): void {
    this.$destroy.next();
    this.$destroy.complete();
  }
}
